import { __read } from "tslib";
import { FMPMonitor } from '../../monitors/performance/fmp-monitor';
import { applyMonitor, onPageLoad } from '../../utils';
import { getPluginConfig, reportOnInitCommonParams } from './utils';
export var FMP_MONITOR_PLUGIN_NAME = 'fmp';
var defaultConfig = {
    renderType: 'CSR',
};
export function FMPMonitorPlugin(client) {
    client.on('init', function () {
        var config = getPluginConfig(client, FMP_MONITOR_PLUGIN_NAME, defaultConfig);
        if (!config) {
            return;
        }
        // TODO：如果新增SPA方法，需要重置 reportOnInitCommonParams
        var _a = __read(applyMonitor(FMPMonitor, config, reportOnInitCommonParams(client)), 1), tirggerFMP = _a[0];
        // trigger fmp
        onPageLoad(function () { return setTimeout(tirggerFMP, 200); });
    });
}
//# sourceMappingURL=fmp.js.map